import { render, staticRenderFns } from "./UserFeedbackForm.vue?vue&type=template&id=c2d6e54e&scoped=true"
import script from "./UserFeedbackForm.vue?vue&type=script&lang=js"
export * from "./UserFeedbackForm.vue?vue&type=script&lang=js"
import style0 from "./UserFeedbackForm.vue?vue&type=style&index=0&id=c2d6e54e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d6e54e",
  null
  
)

export default component.exports